module.exports = __webpack_public_path__ + "img/prioritas_dfod.09a39bd2.png";